import { render } from "./KeywordReviewStatus.vue?vue&type=template&id=a76e2c8a"
import script from "./KeywordReviewStatus.vue?vue&type=script&lang=js"
export * from "./KeywordReviewStatus.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__